import { CheckboxList as DSCheckboxList } from '@boltenergy-be/design-system'
import { CheckboxGroupProps } from './types'
import styles from './CheckboxList.module.scss'

const CheckboxList = ({ children }: CheckboxGroupProps) => {
  return (
    <DSCheckboxList grid="full" label="" listClassName={styles['checkbox-group']}>
      {children}
    </DSCheckboxList>
  )
}

export default CheckboxList
